(() => {
var $8f5e044ddcd6836a$exports = {};
$8f5e044ddcd6836a$exports = JSON.parse('{"name":"","top_notch":"","icons":[{"src":"/android-chrome-192x192.png","sizes":"192x192","type":"image/png"},{"src":"/android-chrome-512x512.png","sizes":"512x512","type":"image/png"}],"theme_color":"#ffffff","background_color":"#ffffff","display":"standalone"}');

})();
//# sourceMappingURL=manifest.017d9733.js.map
